export const CurrentRouteInfoSymbol = Symbol('CurrentRouteInfo')
